import { useNavigate } from "react-router-dom";
import { ArrowRight, MessageCircleQuestion } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useSite } from "@/context/SiteContext";
import { IMAGES } from "@/constants/images";

export default function Hero() {
  const navigate = useNavigate();
  const { settings } = useSite();

  return (
    <section className="relative flex min-h-[85vh] items-center overflow-hidden" data-testid="hero-section">
      <img
        src={settings?.hero_image || IMAGES.heroKaaba}
        alt="Masjidil Haram"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#084C3A]/95 via-[#0F6B4F]/60 to-[#0B4F71]/40" />

      <div className="relative mx-auto max-w-4xl px-4 py-24 text-center sm:px-6 lg:px-8">
        <span className="inline-flex items-center rounded-full border border-white/30 bg-white/10 px-4 py-1.5 text-xs font-medium text-white backdrop-blur-sm">
          KBIHU Muhammadiyah Surabaya &mdash; Bimbingan Haji &amp; Umrah Terpercaya
        </span>
        <h1 className="mt-6 font-heading text-4xl font-bold leading-tight text-white sm:text-5xl lg:text-6xl">
          {settings?.hero_title || "Mempersiapkan Perjalanan Ibadah dengan Ilmu, Bimbingan, dan Ketulusan."}
        </h1>
        <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-white/85 sm:text-lg">
          {settings?.hero_subtitle || "KBIHU Muhammadiyah Surabaya hadir mendampingi jamaah dalam mempersiapkan, memahami, dan menjalankan ibadah Haji dan Umrah dengan lebih baik."}
        </p>
        <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
          <Button
            size="lg"
            data-testid="hero-register-cta"
            onClick={() => navigate("/register")}
            className="h-12 gap-2 rounded-full bg-gradient-to-r from-[#0F6B4F] to-[#1677B8] px-8 text-base text-white hover:opacity-90 transition-opacity"
          >
            Daftar Sekarang <ArrowRight className="h-4 w-4" />
          </Button>
          <Button
            size="lg"
            variant="outline"
            data-testid="hero-consult-cta"
            onClick={() => navigate("/kontak")}
            className="h-12 gap-2 rounded-full border-white/40 bg-white/10 px-8 text-base text-white backdrop-blur-sm hover:bg-white/20"
          >
            <MessageCircleQuestion className="h-4 w-4" /> Konsultasi Haji &amp; Umrah
          </Button>
        </div>
      </div>
    </section>
  );
}
